import { I } from "../Icons.jsx";

export default function Chip({ person, isSelected, isHost, showHosts, onClick, onDragStart, compact }) {
  const name = person?.Name || "?";
  const ini = name.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase();
  const ha = showHosts && isHost;

  return (
    <div
      draggable
      onDragStart={(e) => onDragStart && onDragStart(e, person.id)}
      onClick={(e) => { e.stopPropagation(); onClick && onClick(person.id); }}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 7,
        padding: compact ? "2px 9px 2px 2px" : "3px 11px 3px 3px",
        borderRadius: 999,
        cursor: "grab",
        userSelect: "none",
        fontSize: 12.5,
        transition: "all 0.15s ease",
        background: ha ? "var(--accent-soft)" : isSelected ? "var(--ink-soft)" : "var(--paper-1)",
        border: `1px solid ${ha ? "var(--accent)" : isSelected ? "var(--ink)" : "var(--line)"}`,
        color: "var(--ink)",
        fontFamily: "var(--ui)",
      }}
    >
      <span style={{
        width: compact ? 20 : 22,
        height: compact ? 20 : 22,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 10,
        fontWeight: 600,
        letterSpacing: 0.5,
        background: ha ? "var(--accent)" : "var(--paper-2)",
        color: ha ? "var(--paper-0)" : "var(--ink-2)",
        border: `1px solid ${ha ? "var(--accent)" : "var(--line)"}`,
        flexShrink: 0,
      }}>
        {ha ? <I.star size={10} stroke="currentColor" /> : ini}
      </span>
      <span style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: compact ? 140 : 170,
        fontWeight: ha ? 500 : 450,
      }}>{name}</span>
    </div>
  );
}
